import CreationActions from './CreationActions';
import EditInlineActions from './EditInlineActions';
import EmailActions from './EmailActions';
import ModalActions from './ModalActions';
import UiActions from './UiActions';

export default {
    ...CreationActions,
    ...EditInlineActions,
    ...EmailActions,
    ...ModalActions,
    ...UiActions,
};
